// frontend/src/pages/TatmeenHierarchy/hierarchySlice.js

import { createSlice } from "@reduxjs/toolkit";
import {
  fetchVoucherList,
  fetchHierarchy,
} from "./hierarchyThunk";

const initialState = {
  moduleType: null,
  selectedReferenceId: null,  // ✅ ADD THIS
  vouchers: [],
  hierarchyTree: [],
  unlinkedSSCCs: [],
  validation: null,
  summary: null,
  loading: false,
  error: null,
};

const hierarchySlice = createSlice({
  name: "hierarchy",
  initialState,
  reducers: {
    resetHierarchy: () => initialState,
    // ✅ ADD THIS REDUCER
    setSelectedReferenceId: (state, action) => {
      state.selectedReferenceId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVoucherList.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.vouchers = [];
        state.hierarchyTree = [];
        state.unlinkedSSCCs = [];
        state.validation = null;
        state.summary = null;
        state.selectedReferenceId = null; // ✅ Reset on module change
      })
      .addCase(fetchVoucherList.fulfilled, (state, action) => {
        state.loading = false;
        state.moduleType = action.payload.referenceType;
        state.vouchers = action.payload.list || [];
      })
      .addCase(fetchVoucherList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to fetch vouchers";
      })
      .addCase(fetchHierarchy.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.hierarchyTree = [];
        state.unlinkedSSCCs = [];
        state.validation = null;
        state.summary = null;
      })
      .addCase(fetchHierarchy.fulfilled, (state, action) => {
        state.loading = false;
        state.hierarchyTree = action.payload?.hierarchyTree || [];
        state.unlinkedSSCCs = action.payload?.unlinkedSSCCs || [];
        state.validation = action.payload?.validation || null;
        state.summary = action.payload?.summary || null;
      })
      .addCase(fetchHierarchy.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to fetch hierarchy";
      });
  },
});

export const {
  resetHierarchy,
  setSelectedReferenceId,  // ✅ EXPORT THIS
} = hierarchySlice.actions;

export default hierarchySlice.reducer;